export const SalesEmailAddress = 'sales@cerebrocapital.com';
export const CerebroPhoneNumber = '240-394-1311';
export const CerebroPhoneNumberHref = 'tel:2403941311';
export const LoanRequestUrl = 'https://meetings.hubspot.com/lcampbell1/loan-request-kick-off';
export const EmptyGuid = '00000000-0000-0000-0000-000000000000';
